import Image from 'next/image';
// Material-UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';

import useResponsive from 'hooks/useResponsive';

// ----------------------------------------------------------------------

const CARDS = [
  {
    icon: '/assets/images/returns/rt-1.webp',
    title: 'We take back unsold stock',
    description: '',
  },
  {
    icon: '/assets/images/returns/rt-2.webp',
    title: 'Items must be returned within 60 days',
    description: '',
  },
  {
    icon: '/assets/images/returns/rt-3.webp',
    title: 'Eligible on all brands you have not bought before',
    description: '',
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(4),
}));

const CardStyle = styled(Card)(({ theme }) => {
  return {
    maxWidth: 580,
    minHeight: 128,
    margin: 'auto',
    textAlign: 'center',
    padding: theme.spacing(2),
    boxShadow: 'none',
    backgroundColor: '#F9FAFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  };
});

const CardIconStyle = styled(Box)(() => ({
  width: 40,
  height: 40,
  flexShrink: 0,
}));

// ----------------------------------------------------------------------

const ReturnBanner = () => {
  const isMobile = useResponsive('down', 'sm');

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <Box sx={{ mb: { xs: 1, md: 2 } }}>
          <Typography component="h2" variant="h6" fontWeight="fontWeightMedium" sx={{ textAlign: 'left' }}>
            Risk-Free Returns by Creoate
          </Typography>
        </Box>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {CARDS.map((card) => (
            <Grid key={card.title} item xs={12} md={4}>
              <CardStyle sx={isMobile ? { minHeight: { xs: 65 }, maxHeight: { xs: 110 } } : {}}>
                <Stack direction="row" alignItems="center" spacing={2} textAlign="left" justifyContent="left">
                  <CardIconStyle>
                    <Image
                      src={card.icon}
                      alt={card.title}
                      width={40}
                      height={40}
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                      }}
                    />
                  </CardIconStyle>
                  <Typography component="h2" variant="subtitle1" fontWeight="600">
                    {card.title}
                  </Typography>
                </Stack>
              </CardStyle>
            </Grid>
          ))}
        </Grid>
      </Container>
    </RootStyle>
  );
};

export default ReturnBanner;
